












































































































































import { Component, Vue, Config, BasePage, Model, Watch, Prop } from "@/common";
@Component({})
export default class OrderEdit extends BasePage {
  @Model("change", { type: Boolean })
  private value!: boolean;

  @Watch("value")
  onValueChange(val) {
    this.showEdit = val;
  }

  @Watch("showEdit")
  onShowEditChange(val) {
    if (val === false) {
      this.resetForm("headForm");
      this.head.GUID = "";
    } else {
      if (this.propkey !== "") {
        this.dataLoading = true;
        this.$http
          .post("Basic/Person/GetRecord", {
            GUID: this.propkey,
          })
          .then((res) => {
            this.dataLoading = false;
            if (res.data.status === 0) {
              Object.assign(this.head, res.data.head);
            } else {
              this.$message.warning(res.data.msg || "操作失败");
            }
          });
      }
    }
    this.$emit("change", this.showEdit);
  }

  @Watch("propkey")
  ondataLoadingChange(val) {}

  head = {
    GUID: null,
    GH: null,
    XM: null,
    SFZH: null,
    XB: null,
    CSRQ: null,
    JTZZ: null,
    YX: null,
    ZP: null,
    TYPE: null,
    TEL: null
  };

  dataLoading = false;

  @Prop({})
  private custom!: Array<any>;

  @Prop({})
  private propkey!: String;

  showEdit = false;

  saveMask = false;

  columns = [];

  rules = {
    GH: [{ required: true, message: "请输入工号", trigger: "blur" }],
    XM: [{ required: true, message: "请输入姓名", trigger: "blur" }],
    TEL: [{ required: true, message: "请输入手机号", trigger: "blur" }],
  };

  options = [
    {
      value: "男",
      label: "男",
    },
    {
      value: "女",
      label: "女",
    },
  ];

  typeOptions = [
    {
      value: "行政",
      label: "行政",
    },
    {
      value: "司机",
      label: "司机",
    },
    {
      value: "客户",
      label: "客户",
    },
  ];

  imageUrl = "";
  handleAvatarSuccess(res, file) {
    this.imageUrl = URL.createObjectURL(file.raw);
  }

  beforeAvatarUpload(file) {
    const isJPG = file.type === "image/jpeg";
    const isLt2M = file.size / 1024 / 1024 < 2;

    if (!isJPG) {
      this.$message.error("上传头像图片只能是 JPG 格式!");
    }
    if (!isLt2M) {
      this.$message.error("上传头像图片大小不能超过 2MB!");
    }
    return isJPG && isLt2M;
  }

  Save() {
    this.isFormValid("headForm", (valid) => {
      if (valid) {
        this.saveMask = true;
        this.$http
          .post("Basic/Person/Save", {
            person: this.head,
          })
          .then((res) => {
            if (res.data.status === 0) {
              this.saveMask = false;
              this.$message.success("保存成功");
              this.showEdit = false;
              this.$emit("on-ok");
            } else {
              this.saveMask = false;
              this.$message.warning(res.data.msg || "保存失败");
            }
          })
          .catch((err) => {
            this.saveMask = false;
            this.$message.warning(err);
          });
      }
    });
  }

  mounted() {
    this.showEdit = this.value;
  }
}
